import { gql } from '@apollo/client';

export const ProjectImageFragment = gql`
  fragment ProjectImageParts on Project {
    projectImage {
      id
      url
      thumb_url
      updated_at
    }
  }
`;

export const ProjectPartsFragment = gql`
  fragment ProjectParts on Project {
    id
    name
    number
    conditions_of_acceptance
    customer
    welding_progress
    inspection_progress {
      name
      count
      count_failed
      percent
      inspection_category_type_id
    }
    planned_start_date
    planned_end_date
    depth
    company_ids
    attachments {
      id
      data_file_name
      url
    }
    projectImage {
      id
      url
      thumb_url
      updated_at
    }
    company_permitted
  }
`;

export const ProjectsListQuery = gql`
  query ProjectsListQuery($page: Int, $size: Int) {
    projects(page: $page, size: $size) {
      list {
        ...ProjectParts
      }
    }
    companies {
      list {
        id
        name
      }
    }
  }
  ${ProjectPartsFragment}
`;

export const SAVE_PROJECT = gql`
  mutation createOrUpdateProjects($attributes: ProjectInput!) {
    createOrUpdateProjects(attributes: $attributes) {
      project {
        ...ProjectParts
      }
      errors
    }
  }
  ${ProjectPartsFragment}
`;

export const DELETE_PROJECT = gql`
  mutation destroyProjects($id: ID!) {
    destroyProjects(id: $id) {
      response
    }
  }
`;



export const DELETE_ATTACHMENT = gql`
  mutation destroyAttachments($attachment_id: [Int]!, $attachable_id: Int!, $attachable_type: String!) {
    destroyAttachments(attachment_id: $attachment_id, attachable_id: $attachable_id, attachable_type: $attachable_type) {
      response
    }
  }
`;

export const GET_ELEMENTS = gql`
  query GetElements($projectId: Int!) {
    elements(parent_id: $projectId) {
      list {
        id
        name
        number
        children_count
        planned_start_date
        planned_end_date
        company_ids
        conditions_of_acceptance
        customer
        depth
        attachments {
          id
          data_file_name
          url
        }
      }
    }
  }
`;

export const GET_COMPANIES = gql`
  query GetCompanies {
    companies {
      list {
        id
        name
      }
    }
  }
`;

export const PROJECT_TREE_QUERY = gql`
  query ProjectTree($projectId: ID!) {
    project_tree(project_id: $projectId)
  }
`;

export const MOVE_ELEMENT = gql`
  mutation MoveElement($element_id: ID!, $target_id: ID) {
    moveElements(element_id: $element_id, target_id: $target_id) {
      success
      errors
    }
  }
`;

export const GET_ELEMENT = gql`
  query GetElement($id: ID!) {
    element(id: $id) {
      id
      name
      number
      planned_start_date
      planned_end_date
      customer
      conditions_of_acceptance
      company_ids
      depth
      attachments {
        id
        data_file_name
        url
      }
      projectImage {
        id
        url
        thumb_url
        updated_at
      }
    }
  }
`;
